export const contact_info = {
  tel: [
    { number: "(+48) 501 034 834 ", name: "Roman Kraczla", showIcon: true },
    { number: "(+48) 606 256 213", name: "Joanna Szafarczyk", showIcon: true },
  ],
  email: "kontakt@empatiacentrum.pl",
  adres: "Sokolska 65, lokal 14, 40-087 Katowice",
};
